module.exports = __webpack_public_path__ + "img/site-logo.8a4aedc4.png";